import type { StateCreator } from 'zustand'
import type { PreviewState } from './types'

export interface PreviewSlice extends PreviewState {
  // Utility actions
  clearPreviewError: () => void
  setPreviewLoading: (loading: boolean) => void
}

export const createPreviewSlice: StateCreator<
  PreviewSlice,
  [],
  [],
  PreviewSlice
> = (set) => ({
  // Initial state
  previewData: null,
  productCollections: [],
  brandMaterials: [],
  isLoading: false,
  error: null,

  // Utility actions
  clearPreviewError: () => set({ error: null }),
  setPreviewLoading: (loading: boolean) => set({ isLoading: loading }),
})
